import AuthorizationProvider from './Authorization';
import CallbackPage from './CallbackPage';
import RenewPage from './RenewPage';
import SignoutPage from './SignoutPage';

export { default as useUserManager } from './userManager';
export const Components = { AuthorizationProvider, CallbackPage, RenewPage, SignoutPage };
